import { InMemoryCache } from '@apollo/client';

export const cacheConfig = {};

export default new InMemoryCache(cacheConfig);
